import { ChangeEventHandler, DetailedHTMLProps, InputHTMLAttributes } from "react";
import { useIntl } from "react-intl";

import useHandleRichTextareaFiles from "@hooks/useHandleRichTextareaFiles";

type Props = Omit<
  DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>,
  "aria-label" | "className" | "type"
>;

const RichTextareaFileInput = ({ onChange, ...inputProps }: Props) => {
  const intl = useIntl();

  const handleFiles = useHandleRichTextareaFiles();

  const handleInputChange: ChangeEventHandler<HTMLInputElement> = event => {
    onChange?.(event);
    const files = event.target.files;
    if (files && files.length > 0) {
      handleFiles(files);
    }
  };

  return (
    <input
      accept="*"
      aria-label={intl.formatMessage({ id: "accessibility.ariaLabels.attachFiles" })}
      className="ion-hide"
      multiple
      onChange={handleInputChange}
      type="file"
      {...inputProps}
    />
  );
};

export default RichTextareaFileInput;
